export default __webpack_public_path__ + "static/media/Skechers.58c9d5a9.mp3";